<template>
    <div>
        <div v-if="successMessage" class="alert alert-success" style="color: rgb(5, 20, 48)">
            {{ successMessage }}
        </div>
        <b-card>
            <b-row>
                <div class="col-12 mt-16">
                    <b-form @submit.prevent="addUser" v-if="show">
                        <div style="
                background-color: rgb(97, 116, 152);
                height: 32px;
                border-radius: 4px;
              ">
                            <h4 style="
                  color: rgb(223, 227, 238);
                  margin-left: 5px;
                  font-weight: bold;
                ">
                                Business Partner Information
                            </h4>
                        </div>
                        <div class="row">
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-1" label="Title:" label-for="title">
                                    <b-form-input id="title" type="text" placeholder="Enter title" :state="validateField(title)"
                                        autocomplete="off" v-model="title"
                                        title="Please enter only alphabetic characters" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="About:" label-for="about">
                                    <b-form-textarea id="about" placeholder="Enter about" :state="validateField(about)" v-model="about" required rows="3"></b-form-textarea>
                                </b-form-group>
                            </div>

                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="URL:" label-for="url">
                                    <b-form-input id="url" placeholder="Enter url" :state="validateField(url)" v-model="url" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            
                            <div class="col-md-4 col-12">
                                <!-- <b-form-group id="input-group-2" label="Profile Picture:" label-for="image">
                                    <div style="margin-left: 3px; margin-bottom: 15px">
                                        <input type="file" accept="image/*" id="image"
                                            @change="onProfilePictureChange" required />
                                    </div>
                                </b-form-group> -->
                                <b-form-group
                                label="Profile Image:"
                                description="Recommended size: 300x300px (JPG/PNG)"
                                label-class="font-weight-bold"
                                >
                                <div
                                    class="border rounded p-3 text-center"
                                    style="cursor: pointer; background: #f9f9f9;"
                                    @drop.prevent="onDrop"
                                    @dragover.prevent
                                    @click="$refs.fileInput.click()"
                                >
                                    <div v-if="!imagePreview">
                                    <i class="fas fa-cloud-upload-alt fa-2x text-muted"></i>
                                    <p class="mb-0">Drag & Drop or Click to Upload</p>
                                    </div>
                                    <div v-else>
                                    <img
                                        :src="imagePreview"
                                        alt="Preview"
                                        class="img-thumbnail"
                                        style="max-height: 120px;"
                                    />
                                    </div>
                                    <input
                                    ref="fileInput"
                                    type="file"
                                    accept="image/png, image/jpeg"
                                    class="d-none"
                                    @change="onFileChange"
                                    />
                                </div>
                                <small class="text-muted">
                                    Only JPG/PNG, Max size: 2MB
                                </small>
                                <b-form-invalid-feedback v-if="imageError">
                                    {{ imageError }}
                                </b-form-invalid-feedback>
                                </b-form-group>
                            </div>
                        </div>

                        <!-- Bank Information End -->
                        <b-button type="submit" variant="primary" class="mb-8 mr-8" :disabled="isLoading">
                            <span v-if="!isLoading">Submit</span>
                            <b-spinner v-else class="mb-8 mr-8" variant="primary" small></b-spinner>
                        </b-button>
                    </b-form>
                </div>
                <div v-if="codeActive" class="col-12 mt-24 hljs-container" :class="{ active: codeActiveClass }">
                    <pre v-highlightjs>
          <code class="hljs html">
            {{ codeText }}
          </code>
        </pre>
                </div>
            </b-row>
        </b-card>
    </div>
</template>

<script>
import {
    BRow,
    BCol,
    BCard,
    BButton,
    BForm,
    BFormGroup,
    BFormCheckboxGroup,
    BFormCheckbox,
    BFormSelect,
    BFormInput,
    BSpinner,
    BFormTextarea,
} from "bootstrap-vue";
import axios from "../../../axios";
import { BToast } from "bootstrap-vue";
import code from "@/view/components/data-entry/form/code";
import imageCompression from "browser-image-compression";

export default {
    data() {
        return {
            show: true,
            codeText: code.introduction,
            codeActive: false,
            codeActiveClass: false,
            selectedOption: "",
            fixSalary: "",
            inputField1: "",
            inputField2: "",
            inputField3: "",
            showModal: false,
            isLoading: false,
            // Add Driver
            title: "",
            about: '',
            url: '',
            image: '',
            successMessage: "",
            imagePreview: null,
            imageError: "",


        };
    },
    components: {
        BRow,
        BCol,
        BCard,
        BButton,
        BForm,
        BFormGroup,
        BFormCheckboxGroup,
        BFormCheckbox,
        BFormSelect,
        BFormInput,
        BToast, 
        BSpinner,
        BFormTextarea,
    },

    methods: {
          validateField(value, type = "text") {
            if (value === null || value === undefined || value === "") return null;

            if (type === "email") {
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return regex.test(value);
            }
            if (type === "number") {
            const regex = /^\+?[0-9 ]+$/; // accepts + and spaces
            return regex.test(value.toString().trim());
            }
            return value.toString().trim().length > 0;
        },
        showMsgBoxOne() {
            debugger;
        },
        onSubmit(event) {
            event.preventDefault();
            alert(JSON.stringify(this.form));
        },
       
        addUser() {
            this.isLoading = true;
            this.imageError = "";
            const formData = new FormData();
            formData.append("image", this.image);
            formData.append("about", this.about);
            formData.append("title", this.title);
            formData.append("url", this.url);
            axios

                .post("insuranceCompanyStore", formData)
                .then((response) => {
                    this.$bvToast.toast("Insurance added successfully!", {
                        title: "Success",
                        variant: "primary",
                        solid: true,
                        appendToast: true,
                        toaster: "b-toaster-top-right",
                        autoHideDelay: 5000,
                    });
                    this.isLoading = false;
                    this.$router.push({ name: 'ListInsurance' });
                })
                .catch((error) => {
                    this.errors = error.response.data.errors;
                    this.isLoading = false;
                });
        },
        onProfilePictureChange(event) {
            const file = event.target.files[0];
            if (file) {
                this.image = file;
            }
        },

        vehicleImageChange(event) {
            const files = event.target.files;
            if (files && files.length > 0) {
                // Convert FileList to an array
                this.vehicle_image = Array.from(files);
            }
        },

        BankImageChange(event) {
            const file = event.target.files[0];
            if (file) {
                this.bank_upload_document = file;
            }
        },

        codeClick() {
            this.codeActive = !this.codeActive;
        },

        saveOwnCar() {
            this.showModal = false;
        },
                async onFileChange(event) {
        const file = event.target.files[0];
        await this.handleFile(file);
        },
        async onDrop(e) {
        const file = e.dataTransfer.files[0];
        await this.handleFile(file);
        },
    async handleFile(file) {
      if (!file) return;
      if (!["image/jpeg", "image/png"].includes(file.type)) {
        this.imageError = "Only JPG/PNG allowed.";
        return;
      }
      if (file.size > 2 * 1024 * 1024) {
        this.imageError = "Max size is 2MB.";
        return;
      }

      try {
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 600,
          useWebWorker: true,
        };
        const compressedFile = await imageCompression(file, options);
        this.image = compressedFile;
        this.imagePreview = URL.createObjectURL(compressedFile);
        this.imageError = "";
      } catch (err) {
        this.image = file;
        this.imagePreview = URL.createObjectURL(file);
      }
    },
    },
};
</script>
